export function isArray<T>(value: T | readonly T[]): value is readonly T[] {
  return Array.isArray(value);
}

export type Fraction = readonly [number, number];

export type Numeric = number | Fraction;

export function asFraction(value: Numeric): Fraction {
  if (isFraction(value)) return value;
  return [value, 1];
}

export function isFraction(value: Numeric): value is Fraction {
  return isArray(value);
}
